import React, { useEffect } from "react";

import Main from '../components/Products/Main'
import Switcher from "../components/Products/Switcher";

function Products () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[56px]">
            <Main/>
            <Switcher/>
        </div>
    );
}

export default Products;